import type { ResourceType } from "@app/types";
import {
  IconActivity,
  IconAws,
  IconChartSquareBar,
  IconCircleStack,
  IconCube,
  IconDownload,
  IconEllipsisHorizontal,
  IconEndpoint,
  IconFileText,
  IconGlobeAlt,
  IconKey,
  IconLock,
  IconOrganization,
  IconService,
  IconUsers,
} from "./icons";

const KNOWN_RESOURCE_TYPE_ICONS = [
  "app",
  "backup",
  "certificates",
  "credentials",
  "database",
  "ephemeral_session",
  "environment",
  "horizontal_scale",
  "image",
  "llm_key",
  "log_drain",
  "metric_drain",
  "plan",
  "service",
  "service_deployment_update",
  "unknown",
  "vhost",
];

export const getIconForResourceType = (resourceType: ResourceType | string) => {
  switch (resourceType.toLowerCase()) {
    case "activityexport":
      return <IconDownload />;
    case "app":
      return <IconCube />;
    case "backup":
    case "database":
      return <IconCircleStack />;
    case "endpoint":
      return <IconEndpoint />;
    case "environment":
      return <IconGlobeAlt />;
    case "externalawsaccount":
    case "externalawsresource":
      return <IconAws />;
    case "llmkey":
      return <IconKey />;
    case "logdrain":
      return <IconFileText />;
    case "membership":
    case "role":
    case "user":
      return <IconUsers />;
    case "metricdrain":
      return <IconChartSquareBar />;
    case "operation":
      return <IconEllipsisHorizontal />;
    case "orgnanization":
      return <IconOrganization />;
    case "service":
    case "service_sizing_policy":
    case "service_sizing_policy_membership":
      return <IconService />;
    case "vpntunnel":
      return <IconLock />;
    default:
      return <IconActivity />;
  }
};

export const getImageForResourceType = (
  resourceType: ResourceType | string,
) => {
  const hasIcon = KNOWN_RESOURCE_TYPE_ICONS.includes(resourceType);
  const imageToUse = hasIcon
    ? `/resource-types/logo-${resourceType}.png`
    : "/resource-types/logo-unknown.png";

  return (
    <img
      src={imageToUse}
      className="w-[32px] h-[32px] mr-2 mt-1 align-middle"
      aria-label={resourceType}
    />
  );
};
